{
  "title": "Power Word: Heal",
  "source": "Player's Handbook",
  "levelAndSchool": "9th-level evocation",
  "level": 9,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S",
  "duration": "Instantaneous",
  "description": [
    "A wave of healing energy washes over a creature you touch. The target regains all its hit points. If the creature is charmed, frightened, paralyzed, or stunned, the condition ends. If the creature is prone, it can use its reaction to stand up. This spell has no effect on undead or constructs."
  ],
  "spellLists": ["bard", "cleric"]
}
